import { useState } from 'react';
import styled from 'styled-components';

import imagemDer from '../../assets/imagensDERs/sisafDerModuloFornecedor.png';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.15rem;
  text-align: justify;
  padding: 5px;

  ul {
    margin-bottom: 15px;
  }
`;

const Definicao = styled.div`
  margin-bottom: 20px;
`;

const AbasContainer = styled.div`
  display: flex;
  border-bottom: 2px solid #b0c4de;
  margin-bottom: 15px;
`;

const Aba = styled.div<{ active: boolean }>`
  padding: 10px 20px;
  cursor: pointer;
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};
  background-color: ${({ active }) => (active ? '#869ddb83' : 'transparent')};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  &:hover {
    background-color: #b0c4de;
  }
`;

const ImagemDer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  border-radius: 10px;
  border: 1px solid lightgray;
  background-color: lightgray;
  margin-bottom: 25px;

  img {
    height: 30vh;
    border-radius: 10px;
    width: auto;

    transition: transform 0.3s ease-in-out;

    &:hover {
      /* transform: scale(1.5); */
    }
  }
`;

const AbaDefinicoes = () => {
  return (
    <>
      <ul>
        <li>
          <b>Fornecedor</b>
        </li>
        <ul>
          <li>
            Um fornecedor é uma entidade responsável por fornecer produtos
            farmacêuticos ao Departamento de Assistência Farmacêutica (DAF). Ele
            é identificado por seu CNPJ, razão social e outros dados como
            endereço e contato institucional. O fornecedor é essencial nos
            processos de aquisição e distribuição de produtos, e sua gestão
            inclui o registro de todas as suas informações para garantir a
            integridade e rastreabilidade em contratos e processos aquisitivos.
          </li>
        </ul>

        <li>
          <b>Representante do Fornecedor</b>
        </li>
        <ul>
          <li>
            O representante do fornecedor é o indivíduo indicado pela empresa
            fornecedora para atuar como ponto de contato entre o fornecedor e o
            DAF. Suas informações incluem nome completo, CPF, cargo, telefone e
            email. Esse representante pode ter diferentes funções, como
            comerciais ou técnicas, e é responsável por manter a comunicação
            ativa e eficaz em nome do fornecedor​.
          </li>
        </ul>

        <li>
          <b>Comunicação com o Fornecedor</b>
        </li>
        <ul>
          <li>
            As comunicações com o fornecedor referem-se ao registro formal de
            contatos realizados entre o DAF e o fornecedor. Essas comunicações
            podem incluir ofícios, emails, cartas e outros documentos
            relevantes, com registros detalhados como assunto, destinatário e
            mensagem enviada. O módulo de comunicação garante que todas as
            interações sejam documentadas, facilitando o acompanhamento e o
            cumprimento de prazos e obrigações contratuais​.
          </li>
        </ul>

        <li>
          <b>FAQ</b>
        </li>
        <ul>
          <li>
            O módulo de FAQ (Perguntas Frequentes) centraliza dúvidas comuns e
            informações relevantes relacionadas aos fornecedores e processos de
            aquisição. Os FAQs são organizados por tópicos e respostas, servindo
            como um guia de referência rápida para os usuários do sistema. Isso
            facilita o esclarecimento de questões recorrentes, melhorando a
            eficiência na gestão e comunicação entre o DAF e os fornecedores
          </li>
        </ul>
      </ul>
    </>
  );
};

const Entidades = () => {
  return (
    <>
      <ImagemDer>
        <img src={imagemDer}></img>
      </ImagemDer>

      <b>Entidades</b>
      <ul>
        <li>
          <b>TB_FORNECEDOR</b>
        </li>
        <ul>
          <li>
            Entidade que concentra as informações de identificação do
            fornecedor.
          </li>
        </ul>

        <li>
          <b>TB_FORNECEDOR_REPRESENTANTE</b>
        </li>
        <ul>
          <li>
            Entidade que identifica os representantes técnicos e comerciais do
            fornecedor: nome, cargo e telefone.
          </li>
        </ul>

        <li>
          <b>TB_FORNECEDOR_COMUNICACAO</b>
        </li>
        <ul>
          <li>
            Registros de comunicações formais realizadas com o fornecedor:
            ofício, email, carta e outros.
          </li>
        </ul>

        <li>
          <b>TB_FAQ</b>
        </li>
        <ul>
          <li>
            Entidade que armazena os dados das perguntas mais frequentes sobre
            processos relacionados à fornecedores de produtos farmacêuticos do
            DAF.
          </li>
        </ul>
      </ul>

      <b>Cardinalidades</b>
      <ul>
        <li>
          <b>TB_FORNECEDOR para TB_FORNECEDOR_REPRESENTANTE</b>
        </li>
        <ul>
          <li>
            Cada fornecedor tem um ou muitos representantes, mas cada
            representante está associado a apenas um fornecedor. Um fornecedor
            deve existir para que os representantes possam existir.
          </li>
        </ul>

        <li>
          <b>TB_FORNECEDOR para TB_FORNECEDOR_COMUNICACAO</b>
        </li>
        <ul>
          <li>
            Um fornecedor pode ter zero ou muitas comunicações, mas cada
            registro de comunicação está associado a apenas um fornecedor.
          </li>
          <li>
            É possível que existam fornecedores que não tenham registros de
            comunicação, mas não pode existir um registro de comunicação que não
            esteja vinculado a um fornecedor.
          </li>
        </ul>
      </ul>
    </>
  );
};

const RegrasDeNegocio = () => {
  return (
    <>
      <ul>
        <li>
          <b>Fornecedor</b>
        </li>
        <ul>
          <li>
            Um fornecedor não pode ser deletado caso esteja vinculado a um
            processo aquisitivo ou contrato.
          </li>
          <li>Não pode ter dois registros com o mesmo CNPJ.</li>
          <li>
            Um representante pode estar associado a mais de um fornecedor.
          </li>
        </ul>

        <li>
          <b>FAQ</b>
        </li>
        <ul>
          <li>Não podem existir FAQs com o mesmo título/assunto.</li>
        </ul>
      </ul>
    </>
  );
};

const AjudaModuloFornecedores = () => {
  const [abaAtiva, setAbaAtiva] = useState<
    'definicoes' | 'regras' | 'entidades'
  >('definicoes');

  return (
    <Container>
      <Definicao>
        Módulo que{' '}
        <b>
          centraliza as informações dos fornecedores de produtos farmacêuticos
          do DAF.{' '}
        </b>
        É um módulo central, pois, tem relacionamento direto com processos
        aquisitivos, ARPs e Contratos.
      </Definicao>

      {/* Abas */}
      <AbasContainer>
        <Aba
          active={abaAtiva === 'definicoes'}
          onClick={() => setAbaAtiva('definicoes')}
        >
          Definições
        </Aba>
        <Aba
          active={abaAtiva === 'entidades'}
          onClick={() => setAbaAtiva('entidades')}
        >
          Entidades
        </Aba>
        <Aba
          active={abaAtiva === 'regras'}
          onClick={() => setAbaAtiva('regras')}
        >
          Regras de Negócio
        </Aba>
      </AbasContainer>

      {/* Conteúdo da Aba Ativa */}
      {abaAtiva === 'definicoes' ? (
        <AbaDefinicoes />
      ) : abaAtiva === 'regras' ? (
        <RegrasDeNegocio />
      ) : (
        <Entidades />
      )}
    </Container>
  );
};

export default AjudaModuloFornecedores;
